<template>
  <v-card :loading="loading">
    <template v-if="attorneyReady">
      <v-toolbar
          color="primary"
          dark
          flat
      >
        <v-toolbar-title>
          Доверенность № {{ attorney.number }} от {{ attorney.date.format($store.getters.dateDisplayFormat) }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                  label="Номер доверенности"
                  type="text"
                  v-model="attorney.number"
                  readonly
              />
            </v-col>
            <v-col cols="12" md="3" class="py-0">
              <v-text-field
                  label="Дата выдачи"
                  v-model="attorney.dateFormatted"
                  prepend-icon="event"
                  readonly
              />
            </v-col>
            <v-col cols="12" md="3" class="py-0">
              <v-text-field
                  label="Действительна по"
                  v-model="attorney.expireDateFormatted"
                  prepend-icon="event"
                  readonly
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                  label="Наименование предприятия"
                  type="text"
                  v-model="attorney.customerCompanyName"
                  readonly
              />
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                  label="Адрес предприятия"
                  type="text"
                  v-model="attorney.customerCompanyAddress"
                  readonly
              />
            </v-col>
          </v-row>

          <p class="subtitle-1 font-weight-bold mb-2 mt-5">Данные доверенного лица</p>
          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                  label="Ф.И.О"
                  type="text"
                  v-model="attorney.proxyName"
                  readonly
              />
              <v-text-field
                  label="Должность"
                  type="text"
                  v-model="attorney.proxyPosition"
                  readonly
              />
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                  label="Серия и номер пасспорта"
                  type="text"
                  v-model="attorney.proxyPassportSerialNumber"
                  readonly
              />
              <v-text-field
                  label="Пасспорт кем выдан"
                  type="text"
                  v-model="attorney.proxyPassportIssuer"
                  readonly
              />

              <v-text-field
                  label="Дата выдачи"
                  v-model="attorney.proxyPassportIssueDateFormatted"
                  prepend-icon="event"
                  readonly
              />
            </v-col>

            <v-col cols="12">
              <v-img :src="passportImageFileDataSource"
                     max-height="480"
                     contain />
            </v-col>
          </v-row>

          <p class="subtitle-1 font-weight-bold mb-2 mt-5">Данные договора</p>
          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                  label="На получение от"
                  type="text"
                  v-model="attorney.releaserCompanyName"
                  readonly
              />
            </v-col>
            <v-col cols="12" md="3" class="py-0">
              <v-text-field
                  label="На получение от"
                  type="text"
                  v-model="attorney.documentNumber"
                  readonly
              />
            </v-col>
            <v-col cols="12" md="3" class="py-0">
              <v-text-field
                  label="Дата документа"
                  v-model="attorney.documentDateFormatted"
                  prepend-icon="event"
                  readonly
              />
            </v-col>
          </v-row>

          <p class="subtitle-1 font-weight-bold mb-2 mt-5 d-flex">Перечень материальных ценностей, подлежащих получению
          </p>
          <v-simple-table
              :fixed-header="true"
              :dense="true"
          >
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">#</th>
                <th class="text-left">Товар</th>
                <th class="text-center">Единица измерения</th>
                <th class="text-center">Количество</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in attorney.items">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-left">
                  <v-text-field
                      v-model="item.product"
                      class="py-0"
                      readonly
                  />
                </td>
                <td class="text-center">
                  <v-text-field
                      v-model="item.measurement"
                      class="py-0"
                      readonly
                  />
                </td>
                <td class="text-center">
                  <v-text-field
                      v-model="item.quantity"
                      class="py-0"
                      type="number"
                      readonly
                  />
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-form>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import AttorneyService from '@/services/attorney.service'

import _ from 'underscore'
import moment from 'moment'

export default {
  name: "AttorneyPage",

  data(){
    return {
      loading: false,
      attorney: null
    };
  },
  computed: {
    attorneyReady() {
      return this.attorney !== null;
    },
    passportImageFileDataSource() {
      if (this.attorneyReady) {
        return `data:image/jpeg;base64,${this.attorney.imageFileBase64}`;
      }
      return '#';
    }
  },
  methods: {
    loadAttorney() {
      const id = this.$route.params.id;

      this.loading = true;
      this.attorney = null;

      AttorneyService.getInfo(id)
          .then(response => {
            this.attorney = {
              id: response.data.Id,
              imageFileBase64: response.data.ImageFileBase64,
              number: response.data.Number,
              date: moment(response.data.Date),
              dateFormatted: moment(response.data.Date).format('YYYY-MM-DD'),
              expireDate: moment(response.data.ExpireDate),
              expireDateFormatted: moment(response.data.ExpireDate).format('YYYY-MM-DD'),
              customerCompanyName: response.data.CustomerCompanyName,
              customerCompanyAddress: response.data.CustomerCompanyAddress,
              proxyName: response.data.ProxyName,
              proxyPosition: response.data.ProxyPosition,
              proxyPassportSerialNumber: response.data.ProxyPassportSerialNumber,
              proxyPassportIssuer: response.data.ProxyPassportIssuer,
              proxyPassportIssuerDate: moment(response.data.ProxyPassportIssuerDate),
              proxyPassportIssueDateFormatted: moment(response.data.ProxyPassportIssuerDate).format('YYYY-MM-DD'),
              releaserCompanyName: response.data.ReleaserCompanyName,
              documentNumber: response.data.DocumentNumber,
              documentDate: moment(response.data.DocumentDate),
              documentDateFormatted: moment(response.data.DocumentDate).format('YYYY-MM-DD'),
              createdOn: moment(response.data.CreatedOn),
              items: _.map(response.data.Items, i => {
                return {
                  id: i.Id,
                  product: i.Product,
                  measurement: i.Measurement,
                  quantity: i.Quantity
                };
              })
            };
          })
          .catch (() => {
            this.$router.go(-1);
          })
          .finally(() => {
            this.loading = false;
          });
    }
  },
  mounted() {
    this.loadAttorney();
  }
}
</script>

<style scoped>

</style>